import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import { Box, Flex, Text } from "@chakra-ui/react";
import { FaBolt, FaHeadset, FaLocationDot } from "react-icons/fa6";

import "./marketing.css";
import { useAuthentication } from "../../wrappers/UseAuthentication";

import LandingNavbar from "../landing/components/LandingNavbar";
import MarketingFooter from "./components/MarketingFooter";
import PageHero from "./components/PageHero";
import ContactSplit from "./components/contact/ContactSplit";

const TRUST_BADGES = [
  { icon: FaBolt, title: "< 1 business day", sub: "Average response time" },
  {
    icon: FaLocationDot,
    title: "Cape Town · Joburg",
    sub: "Built in South Africa, used everywhere",
  },
  { icon: FaHeadset, title: "Real humans", sub: "No chatbots on this form" },
];

const TrustBadges = () => (
  <Flex gap="14px" wrap="wrap" mt="6px">
    {TRUST_BADGES.map((b) => (
      <Flex
        key={b.title}
        align="center"
        gap="12px"
        padding="12px 16px"
        bg="rgba(255,255,255,0.10)"
        border="1px solid rgba(255,255,255,0.18)"
        backdropFilter="blur(10px)"
        borderRadius="16px"
      >
        <Flex
          w="36px"
          h="36px"
          borderRadius="10px"
          bg="rgba(255,255,255,0.16)"
          align="center"
          justify="center"
          color="white"
          fontSize="14px"
        >
          <b.icon />
        </Flex>
        <Box>
          <Text fontSize="14px" fontWeight={700} color="white" lineHeight="1.2">
            {b.title}
          </Text>
          <Text fontSize="11px" color="rgba(255,255,255,0.75)" mt="2px">
            {b.sub}
          </Text>
        </Box>
      </Flex>
    ))}
  </Flex>
);

const Contact = () => {
  const { isAuthenticated } = useAuthentication();
  if (isAuthenticated) return <Navigate to="/sales" replace />;

  return (
    <>
      <Helmet>
        <title>Contact — SpearBI</title>
        <meta
          name="description"
          content="Talk to the team behind Spearbi. Sales questions, support tickets, partnerships, press — all of it lands in front of a real person."
        />
      </Helmet>

      <Box
        bg="#ffffff"
        color="#0a0e1a"
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif"
        minH="100vh"
        overflowX="hidden"
        sx={{ WebkitFontSmoothing: "antialiased" }}
      >
        <LandingNavbar />
        <PageHero
          eyebrow="Contact"
          title="Talk to the team behind Spearbi."
          subtitle="Sales questions, support tickets, partnership ideas, press — all of it lands in front of a real person."
          height={420}
        >
          <TrustBadges />
        </PageHero>
        <ContactSplit />
        <MarketingFooter />
      </Box>
    </>
  );
};

export default Contact;
